// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

/**
 * Handle toggle of address form (private / company)
 */
(function ($) {

  var checkLayout = function (el) {
    let val = el.val();
    let form = el.closest('form');
    let private_field = form.find('.private-type-field');
    let company_field = form.find('.company-type-field');
    let btn = form.find('.btn[type=submit]');

    if (val === 'COMPANY') {
      private_field.removeClass('show');
      company_field.addClass('show');
      company_field.find('input:not(.optional)').prop('required', true);
    } else {
      private_field.addClass('show');
      company_field.removeClass('show');
      company_field.find('input:not(.optional)').prop('required', false);
    }

    if (form.get(0).checkValidity() === true) {
      btn.prop('disabled', false);
    } else {
      btn.prop('disabled', true);
    }

    $(document).trigger('plenigo.resize');
    $('body').trigger('plenigo.resize');
  };

  $(document).on('change input', '#addressType input', function () {
    checkLayout($(this));
  });

  if ($('#addressType input').length) {
    checkLayout($('#addressType input:checked'));
  }
}(jQuery));



$(document).on('change', '#need-address', function () {
  let el = $(this);
  let form = el.closest('form');
  let btn = form.find('.btn[type=submit]');

  let country_field = form.find('#billing-country').closest('.form-row');

  country_field.remove();

  if (el.is(':checked')) {
    form.find('.address-wrap').append(country_field);
    form.find('.address-wrap').show();
    form.find('.address-wrap .form-control:not(#billing-additional-address)').prop('required', true);
  } else {
    el.closest('.form-group').before(country_field);
    form.find('.address-wrap').hide();
    form.find('.address-wrap .form-control:not(#billing-additional-address)').prop('required', false);
  }

  if (form.get(0).checkValidity() === true) {
    btn.prop('disabled', false);
  } else {
    btn.prop('disabled', true);
  }
});

$(function(){
  $('form .form-control').each(function () {

    let input = $(this);
    input.trigger('change');
    if (input.not('.filled') && input.val()){
      input.addClass('filled').trigger('change');
    }
  });

  $('#need-address:checked').trigger('change');
});

$('.show-password').on('click keydown', function(event) {
  let el = $(this);
  let input = el.parent().find('input');
  if (event.type === 'keydown' && event.key !== 'Enter') {
    return;
  }
  if(input[0].type === 'password') {
    el.addClass('active');
    input[0].type = 'text';
  } else {
    input[0].type = 'password';
    el.removeClass('active');
  }
});
$('#andere_lieferanschrift_tab').on('change', function() {
  let el = $(this);
  let form = $(this).closest('form');
  let btn = form.find('.btn[type=submit]');
  if(el.is(':checked')) {
    $('#andere_lieferanschrift').show();
    let datatype = $('#andere_lieferanschrift').find('input[name=aldata-type]:checked');
    $('#andere_lieferanschrift').find('input:not(.optional)').prop('required', true);
    $('#andere_lieferanschrift').find('select:not(.optional)').prop('required', true);
    if(datatype.val() === 'company') {
      $('#andere_lieferanschrift .private-type-field input').prop('required', false);
      $('#andere_lieferanschrift .private-type-field select').prop('required', false);
    } else {
      $('#andere_lieferanschrift .company-type-field input').prop('required', false);
      $('#andere_lieferanschrift .company-type-field select').prop('required', false);
    }
  } else {
    $('#andere_lieferanschrift').hide();
    $('#andere_lieferanschrift').find('input:not(.optional)').prop('required', false);
    $('#andere_lieferanschrift').find('select:not(.optional)').prop('required', false);
  }

  if (form.get(0).checkValidity() === true) {
    btn.prop('disabled', false);
  } else {
    btn.prop('disabled', true);
  }
});
$(document).on('change', 'input[name="data-type"]', function () {
  let val = $(this).val();
  let form = $(this).closest('form');
  let private_field = form.find('.main-data .private-type-field');
  let company_field = form.find('.main-data .company-type-field');
  let btn = form.find('.btn[type=submit]');

  if (val === 'company') {
    private_field.removeClass('show');
    private_field.find('input:not(.optional)').prop('required', false);
    company_field.addClass('show');
    company_field.find('input:not(.optional)').prop('required', true);
    company_field.find('select:not(.optional)').prop('required', true);
  } else {
    private_field.addClass('show');
    private_field.find('input:not(.optional)').prop('required', true);
    company_field.removeClass('show');
    company_field.find('input:not(.optional)').prop('required', false);
    company_field.find('select:not(.optional)').prop('required', false);
  }

  if (form.get(0).checkValidity() === true) {
    btn.prop('disabled', false);
  } else {
    btn.prop('disabled', true);
  }
});
$(document).on('change', 'input[name="aldata-type"]', function () {
  let val = $(this).val();
  let form = $(this).closest('form');
  let private_field = form.find('.additional-data .private-type-field');
  let company_field = form.find('.additional-data .company-type-field');
  let btn = form.find('.btn[type=submit]');

  if (val === 'company') {
    private_field.removeClass('show');
    private_field.find('input:not(.optional)').prop('required', false);
    company_field.addClass('show');
    company_field.find('input:not(.optional)').prop('required', true);
    company_field.find('select:not(.optional)').prop('required', true);
  } else {
    private_field.addClass('show');
    private_field.find('input:not(.optional)').prop('required', true);
    company_field.removeClass('show');
    company_field.find('input:not(.optional)').prop('required', false);
    company_field.find('select:not(.optional)').prop('required', false);
  }

  if (form.get(0).checkValidity() === true) {
    btn.prop('disabled', false);
  } else {
    btn.prop('disabled', true);
  }
});

$(document).on('input', '.token-input input', function (e) {
  const cursorPos = e.currentTarget.selectionStart;
  let val = this.value;
  val = val.replace(/\D/g, '');
  $(this).val(val);
  if (val.length >= 1) {
    $(this).val(val[0]);
    val = val.substr(1);
    let $next = $(this).next();
    if ($next.length) {
      if($next.hasClass('token-interrupter'))
        $next = $next.next();
      if(val.length > 1) {
        $next.val(val);
        $next.focus();
        $next.trigger('input');
      } else if(cursorPos === 2 && val.length === 1) {
        $next.val(val);
        $next.focus();
      } else {
        $next.focus();
        $next.prop('selectionStart', 0);
        $next.prop('selectionEnd', 0);
      }
    } else {
      $(this).blur();
    }
  }
});
